import axios from "axios";

export function resetPasswordAPI(action) {

  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND}/resetpassword`,
        {
          currentPassword: action.currentPassword,
          newPassword: action.newPassword,
        },
        metaData
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}
